import { getPersonTaxInformation } from '@dealstack/frontend/app/services/Person.service.ts';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { deletePersonTaxInfoRequest } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/apis/useTaxInformation.ts';
import { GetPersonTaxInformationRes } from '@dealstack/shared/lib/generated';

export const useTaxInformation = () => {
	const { selectedEntityId } = useContext(CapManageControllerContext);
	const [addTaxInfo, setAddTaxInfo] = useState<boolean>(false);
	const [editTaxInfo, setEditTaxInfo] = useState<GetPersonTaxInformationRes | null>(null);
	const [deleteTaxInfo, setDeleteTaxInfo] = useState<GetPersonTaxInformationRes | null>(null);

	const {
		data: taxInfo,
		isFetching: taxInfoFetching,
		refetch: refetchTaxInfo,
	} = useQuery({
		queryKey: ['taxInfo', selectedEntityId],
		queryFn: () => getPersonTaxInformation(selectedEntityId),
		enabled: !!selectedEntityId,
	});

	const deletePersonTaxInfoMutation = useMutation({
		mutationFn: deletePersonTaxInfoRequest,
	});

	const deletePersonTaxInfo = () => {
		if (!deleteTaxInfo) {
			return;
		}

		deletePersonTaxInfoMutation.mutate(
			{
				personId: selectedEntityId,
				taxId: deleteTaxInfo.id,
			},
			{
				onSuccess: () => {
					void refetchTaxInfo();
					setDeleteTaxInfo(null);
				},
			}
		);
	};

	return {
		taxInfo: taxInfo ?? [],
		isTaxInfoLoading: taxInfoFetching,
		refetchTaxInfo,
		deletePersonTaxInfo,
		deleteTaxInfo,
		setDeleteTaxInfo,
		editTaxInfo,
		setEditTaxInfo,
		addTaxInfo,
		setAddTaxInfo,
		deletePersonTaxInfoLoading: deletePersonTaxInfoMutation.isPending,
		deletePersonTaxInfoSuccess: deletePersonTaxInfoMutation.isSuccess,
	};
};
